<template>
  <div class="WarehousingList">
    <div class="bg_black text_white">
      <div class="ninew bodybox">
        <van-nav-bar
          left-arrow
          fixed
          @click-left="goback"
          :title="
            type == 'add' ? $t('itemInfo.addUnit') : $t('itemInfo.editUnit')
          "
        >
          <van-icon
            v-if="id"
            name="./static/img/Trash.png"
            slot="right"
            @click="delunit()"
            style="font-size: 24px"
          />
        </van-nav-bar>
      </div>
    </div>

    <!-- 表單模塊 -->
    <div class="shopList ninew bodybox">
      <van-cell-group>
        <van-field
          v-model="form.name"
          :label="$t('itemInfo.unitName')"
          clearable
          :placeholder="$t('itemInfo.unitInputName')"
        />
      </van-cell-group>
      <van-cell-group>
        <van-field
          v-model="form.symbol"
          :label="$t('itemInfo.unitsymbol')"
          clearable
          :placeholder="$t('itemInfo.unitInputsymbol')"
        />
      </van-cell-group>
      <van-button class="testBtn" round @click="submit">{{
        $t("PackageDish.save")
      }}</van-button>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      type: "add",
      form: {
        name: "",
        symbol: "",
      },
      id: "",
    };
  },
  mounted() {
    if (this.$route.query.id) {
      this.id = this.$route.query.id;
      this.$axios({
        method: "get",
        headers: {
          Authorization: "Bearer " + sessionStorage.token,
        },
        url: this.$build + `/api/unit/${this.id}/show`,
      })
        .then((res) => {
          if (res.data.status == 200) {
            console.log(res.data.data);
            this.form.name = res.data.data.name;
            this.form.symbol = res.data.data.symbol;
          } else {
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item],
              });
            }
          }
        })
        .catch((err) => {});
    }
  },
  methods: {
    delunit() {
              this.$dialog
        .confirm({
          title: this.$t("itemInfo.deleteUnitP"),
          message: this.$t("itemInfo.isDeleteUnitP"),
          confirmButtonColor: "#2f75f4",
          confirmButtonText: this.$t("vantText.confirm"),
          cancelButtonText: this.$t("vantText.cancel"),
        })
        .then(() => {
          this.$axios({
            method: "delete",
            headers: {
              Authorization: "Bearer " + sessionStorage.token,
            },
            url: this.$build + `/api/unit/${this.id}/destroy`,
            data: null,
          })
            .then((res) => {
              console.log(res.data);
              if (res.data.status == 200) {
                this.$toast({
                  type: "success",
                  message: this.$t("itemInfo.successDelMsg"),
                });
                const vm = this;
                setTimeout(function () {
                  vm.$router.go(-1);
                }, 1500);
              } else {
                for (var item in res.data.error) {
                  this.$toast({
                    type: "fail",
                    message: res.data.error[item],
                  });
                }
              }
            })
            .catch((err) => {
              this.$toast({
                type: "fail",
                message: this.$t("ShopList.message"),
              });
            });
        });
    },
    goback() {
      this.$router.go(-1); //返回上一层
    },
    submit() {
      var data = {
        name: this.form.name,
        symbol: this.form.symbol,
      };
      if (this.id) {
        this.$axios({
          method: "patch",
          headers: {
            Authorization: "Bearer " + sessionStorage.token,
          },
          data: data,
          url: this.$build + `/api/unit/${this.id}/update`,
        })
          .then((res) => {
            if (res.data.status == 200) {
              this.$toast({
                type: "success",
                message: this.$t("itemInfo.editSuccessMsg"),
              });
              const vm = this;
              setTimeout(function () {
                vm.$router.go(-1);
              }, 1500);
            } else {
              for (var item in res.data.error) {
                this.$toast({
                  type: "fail",
                  message: res.data.error[item],
                });
              }
            }
          })
          .catch((err) => {});
      } else {
        this.$axios({
          method: "post",
          headers: {
            Authorization: "Bearer " + sessionStorage.token,
          },
          data: data,
          url: this.$build + `/api/unit/store`,
        })
          .then((res) => {
            if (res.data.status == 200) {
              this.$toast({
                type: "success",
                message: this.$t("itemInfo.successMsg"),
              });
              const vm = this;
              setTimeout(function () {
                vm.$router.go(-1);
              }, 1500);
            } else {
              for (var item in res.data.error) {
                this.$toast({
                  type: "fail",
                  message: res.data.error[item],
                });
              }
            }
          })
          .catch((err) => {});
      }
    },
  },
};
</script>
<style scoped>
/deep/ .van-nav-bar .van-icon {
  font-size: 24px;
  color: #fff;
}
/deep/ .van-nav-bar__left {
  padding: 0;
  left: -4px;
}
/deep/ .van-nav-bar__right {
  padding: 0;
}
/deep/ .van-cell-group--inset {
  margin: 0;
  margin-top: 15px;
}

.shopList {
  /* padding-top: 20px; */
}
.testBtn {
  width: 50%;
  margin: 15px 25%;
  background: #2f75f4;
  color: #fff;
}
</style>


// WEBPACK FOOTER //
// src/Platform/AddUnitList.vue